import { AtonHost } from '@ais-ui/api';
import { useMemo } from 'react';
import { AtonWithRelations, ServiceMatch } from '../../types';

export const useAtonRelations = (
  aton: AtonHost | null,
  services: any,
  atonStations: any,
  atonServiceDefinitions: any
): AtonWithRelations | null => {
  return useMemo(() => {
    if (
      !atonStations?.records ||
      !atonServiceDefinitions?.records ||
      !services
    ) {
      return null;
    }

    const matchingStation = findMatchingStation(
      atonStations.records,
      aton?.id ? aton.id : ''
    );
    const matchingServiceDefinitions = findMatchingServiceDefinitions(
      atonServiceDefinitions.records,
      services
    );

    return {
      ...aton,
      atonStation: matchingStation,
      atonServices: matchingServiceDefinitions,
    } as AtonWithRelations;
  }, [aton, services, atonStations, atonServiceDefinitions]);
};
// Helper functions for finding matching data
const findMatchingStation = (stations: any[], atonId: string) => {
  return stations.find((station) => station.name === atonId) || null;
};

const findMatchingServiceDefinitions = (
  serviceDefinitions: any[],
  services: any
): ServiceMatch[] => {
  const serviceNames = Object.keys(services);

  return serviceDefinitions
    .filter((serviceDef) => serviceNames.includes(serviceDef.name))
    .map((serviceDef) => ({
      serviceDefinition: serviceDef,
      serviceData: services[serviceDef.name],
      serviceName: serviceDef.name,
    }));
};
